<template>
    <div>
        <component style="display: none" :is="show_document"></component>

        <CRow>
            <CCol md="12" class="mb-4">
                <CCard>
                    <CCardHeader>
                        <CRow>
                            <CCol>
                                <strong>{{$t('sidebars.listDocuments')}}</strong>
                            </CCol>
<!--                            <CCol  style="text-align: end;">-->
<!--                                <CButton @click="AddAllRefer()" size="sm" color="primary">-->
<!--                                    {{ $t('components.referSelected') }}-->
<!--                                </CButton>-->
<!--                            </CCol>-->

                        </CRow>
                        <CRow>
                            <CCol col="3">
                                <date-picker

                                        :label="$t('components.startDate')"
                                        v-model="start_date"></date-picker>
                            </CCol>
                            <CCol col="3">
                                <date-picker
                                        :label="$t('components.endDate')"
                                        v-model="end_date"></date-picker>

                            </CCol>
                            <CCol col="1">
                                <CButton @click="get_all_data" color="dark"
                                         size="sm">
                                    <CIcon size="sm" name="cil-zoom"/>
                                </CButton>
                            </CCol>
                        </CRow>

                    </CCardHeader>
                    <CCardBody>

                        <CCard v-if="submit_refer!=0">
                            <CCardHeader>
                                <strong>{{ $t('components.referToUser') }}</strong>
                            </CCardHeader>
                            <CCardBody>
                                <CForm>


                                    <CCol sm="6" md="4">
                                        <CRow>
                                            <CCol sm="12">
                                                <treeselect
                                                        v-model="refer_person"

                                                        :async="true"
                                                        :load-options="load_persons"
                                                        :placeholder="$t('components.searchUser')"
                                                        :normalizer="normalizer_persons"
                                                />

                                            </CCol>
                                        </CRow>

                                    </CCol>

                                </CForm>
                            </CCardBody>
                            <CCardFooter>
                                <CButton @click="insert_refer()" type="submit" size="sm" color="primary">
                                    <CIcon name="cil-check-circle"/>
                                    {{ $t('components.referToUser') }}
                                </CButton>

                                <CButton @click="submit_refer = 0,id_checkbox_items=[]" type="reset" size="sm"
                                         color="danger">
                                    <CIcon name="cil-ban"/>
                                    {{ $t("buttons.cancel") }}
                                </CButton>
                            </CCardFooter>
                        </CCard>
                        <CDataTableFixed
                                :items="items_sell"
                                :fields="fields"
                                column-filter
                                @row-clicked="table_row_clicked"
height="350px"
                                hover
                                sorter
                                border
                                striped
                                :sorter-value="{column:'id',asc:false}"
                        >
                            <template #row_id="{item,index}">

                                <td :class="get_style(item)">
                                    <p style="text-align: center">{{ index + 1 }}</p>

                                </td>

                            </template>
                            <template #docDate="{item}">

                              <td :class="get_style(item)">
                                    <p style="text-align: center">{{ get_date(item.docDate) }}</p>

                                </td>

                            </template>

                            <template #docMasterCode="{item}">
                              <td :class="get_style(item)">
                                    <p style="text-align: center">{{ item.docMasterCode }}</p>

                                </td>

                            </template>
                            <template #summary="{item}">

                              <td :class="get_style(item)">
                                    <p style="text-align: center">{{ item.summary }}</p>

                                </td>


                            </template>
                            <template #refrenceCode="{item}">

                              <td >
                                    <p style="text-align: center" v-if="item.refrenceCode!=null">{{ item.refrenceCode }} - {{item.summary}}</p>
                                </td>
                            </template>
                            <template #docTypeTitle="{item}">

                              <td :class="get_style(item)">
                                    <p >{{ item.docTypeTitle }}</p>

                                </td>

                            </template>
                            <template #price="{item}">

                              <td :class="get_style(item)">
                                    <p style="float: right">{{ get_currency(get_total_price(item)) }}</p>

                                </td>

                            </template>


                            <template #operation="{item}">
                              <td :class="get_style(item)">
                                    <CButton v-if="item.statusId !=0"
                                             color="primary"
                                             variant="outline"
                                             square
                                             :title="$t('buttons.returnDocument')"
                                             size="sm"
                                             @click="goReturnDocument(item)"
                                    >
                                        <CIcon name="cilTransfer"/>
                                    </CButton>
                                    <CButton
                                            class="m-1"
                                            color="primary"
                                            variant="outline"
                                            square
                                            :title="$t('buttons.show')"
                                            size="sm"
                                            @click="goShowDocument(item)"
                                    >
                                        <CIcon name="cil-speedometer"/>
                                    </CButton>
                                    <CButton
                                            class="m-1"
                                            color="success"
                                            square
                                            size="sm"
                                            :title="$t('buttons.print')"
                                            @click="goPrintDocument(item)"
                                    >
                                        <CIcon name="cil-print"/>
                                    </CButton>
                                    <CButton v-if="item.statusId !=0 && item.toziKonande==null"
                                             class="m-1"
                                             color="primary"
                                             variant="outline"
                                             square
                                             :title="$t('buttons.refer')"
                                             size="sm"
                                             @click="AddRefer(item)"
                                    >
                                        <CIcon name="cilShare"/>
                                    </CButton>

                                    <CButton v-if="item.statusId ==0"
                                             class="m-1"
                                             color="primary"
                                             square
                                             size="sm"
                                             :title="$t('buttons.finalize')"
                                             @click="Finalize(item)"
                                    >
                                        <CIcon name="cil-https"/>
                                    </CButton>


                                </td>
                            </template>

                            <template #select="{item}">
                                <td >

                                    <CCol v-if="item.statusId !=0 && item.toziKonande==null">

                                        <input type="checkbox" ref="permissions[]" v-model="id_checkbox_items"
                                               :value="item.recId"/>

                                    </CCol>

                                </td>
                            </template>
                        </CDataTableFixed>
                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {ASYNC_SEARCH} from '@riophae/vue-treeselect'
    import moment from 'moment-jalaali'

    var simulateAsync=null
    const simulateAsyncOperation = fn => {
        if(simulateAsync!=null){
            clearTimeout(simulateAsync)
        }
        simulateAsync =  setTimeout(fn, 1000)
    }
    var items_data = [];


    export default {
        name: 'Login',
        components: {
            Treeselect,
            'test-dynamic': () => import('../documents/PrintDocument'),

        },
        data() {
            return {
                confirm_delete_name:"confirm"+new Date().getTime()+"_"+this.$vnode.tag,
                show_document: 'test-dynamic',
                printed_doc_id: 0,
                name: '',


                start_date: '',
                end_date: '',
                submit_refer: 0,
                refer_person: null,
                selected_template: 0,
                id_checkbox_items: [],
                item_sell_array: [],

                items_sell: [],
                table_clicks_timer:'',
                table_clicks:0,

                fields: [
                    {key: 'row_id', label: this.$t('tables.sharp'),sorter:false, _style: 'width:2%'},
                    {key: 'docMasterCode', label: this.$t('docNumber'), _style: 'width:5%'},
                  {key: 'docDate', label: this.$t('docDate'), _style: 'width:5%'},
                  {key: 'docTypeTitle', label: this.$t('documentType') , _style: 'width:3%'},

                    {key: 'refrenceCode', label: this.$t('referenceNo'), _style: 'width:10%'},

                    // {key: 'summary', label: this.$t('description'), _style: 'width:10%'},

                    // {key: 'انبار', _style: 'width:10%'},

                    {key: 'price', label: this.$t('tables.amount'), _style: 'width:5%'},

                ],


                details: [],

                status_form: 0,
                load_persons({action, searchQuery, callback}) {
                    var self = this;

                    if (action === ASYNC_SEARCH) {
                        simulateAsyncOperation(() => {
                            let options;
                            const formData = new FormData();

                            formData.append('SearchTxt', searchQuery);

                            axios.post('GetUsers', formData, {show_pros: true}).then(function (response) {
                                options = response.data.data;

                                callback(null, options);

                                // localStorage.setItem("api_token", response.data.access_token);
                                // self.$router.push({ path: 'notes' });
                            })
                                .catch(function (error) {

                                    console.log(error);
                                });


                            //  const options = this.get_keywords(searchQuery);
                            // const options = [1, 2, 3, 4, 5].map(i => ({
                            //     id: `${searchQuery}-${i}`,
                            //     name: `${searchQuery}-${i}`,
                            // }))

                        })
                    }
                },
                normalizer_persons(node) {
                    return {
                        id: node.userId,
                        label: node.personCode +" "+ node.userName +" "+ node.surName+" "+ node.mobileNo,
                    }
                },

            }
        }, mounted() {

            this.start_date = this.get_day_before_today_in_day(5);
            this.end_date = this.get_today();

            this.$root.root_validate_errors = [];

            this.get_all_data();

            bus.$on("update_add_docs", (data) => {
                // alert(data);
              this.get_all_data();

            });
            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.person_id': function () {
                this.get_all_data();
            },
            // 'start_date': function () {
            //     this.get_all_data();
            // },
            // 'end_date': function () {
            //     this.get_all_data();
            // }
        },
        methods: {
get_style(item){
  if(item.isFinal==0){
    return 'bg-warning'
  }else{
    return '';
  }
},
          get_total_price(item){
            var total=0;
            item.details.forEach((val) =>{
              total+=Math.abs(val.debtor);
            })
            return total;
          },
            table_row_clicked(item, index) {

                this.table_clicks++;
                if (this.table_clicks == 1) {
                    this.table_clicks_timer = setTimeout(() => {
                        // this.result.push(event.type);
                        this.table_clicks = 0
                    }, 500);
                } else if (this.table_clicks > 1) {
                    clearTimeout(this.table_clicks_timer);
                    this.goShowDocument(item)
                    this.table_clicks = 0

                }

            },
            get_all_data() {
                this.get_lists_sell(0);

            },

            get_lists_sell(page) {

                var self = this;


                const formData = new FormData();

                var url = "GetAccountDocList";

                formData.append("FirstDate", self.start_date);
                formData.append("SecondDate", self.end_date);
                formData.append("PageNo", page);
if(page==0){
  self.items_sell=[]
}
                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {


                      let res_data =  content_data.data
                      self.items_sell = self.items_sell.concat(...res_data)
                      if(res_data.length>0){
                        self.get_lists_sell(page+1)
                      }else{
                        self.items_sell.sort(function(a, b) {
                          return (b.id - a.id);
                        })
                        // console.log(self.items_sell)
                      }
                    } else {

                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });


            },

            Finalize(item) {
                var self = this;


                const formData = new FormData();

                var url = "AddFactorToFinal";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            send_to_customer(item) {
                var self = this;


                const formData = new FormData();

                var url = "SendFactorToTelegramBoth";

                formData.append("id", item.recId);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    self.$root.modal_component.show_api_response_modals(response);

                    if (content_data.statusCode == 0) {
                        item.statusId = 1;
                    } else {
                        // self.$root.modal_component.show_danger_modal('خطا', content_data.message);

                    }

                })
                    .catch(function (error) {
                        console.log(error);
                    });

            },
            goReturnDocument(item) {
                this.$router.push({
                    path: '/dashboard/documents/return/' + item.recId + "/false",
                    params: {passed_data: "salam hamidddd"}
                });
            },
            goShowDocument(item) {

                // this.$router.push({path: '/dashboard/accounting/show-accounting-doc/' + item.id});
                window.open('/dashboard/accounting/show-accounting-doc/' + item.id)
            },
            goPrintDocument(item) {
                bus.$emit("print_confirm", item.recId);


            },
            AddRefer(item) {
                this.submit_refer = item.recId;
            },

            AddAllRefer() {
                this.submit_refer = -1;
                if (this.id_checkbox_items.length == 0) {
                    console.log("validate form is false" + this.validate_errors);
                    this.submit_refer = 0;

                }
            },

            insert_refer() {
                let self = this;

                if (this.submit_refer != -1) {


                    this.id_checkbox_items = [];
                } else {
                    if (this.id_checkbox_items.length == 0) {
                        console.log("validate form is false" + this.validate_errors);
                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        return true;
                    }

                }
                if (this.refer_person == null) {
                    console.log("validate form is false" + this.validate_errors);

                    return true;
                }
                let url;
                // if (this.status_form == 0) {
                url = "AddFactorRefer";
                // }
                if (this.submit_refer != -1) {
                    const formData = new FormData();

                    formData.append('PersonId', this.refer_person);

                    formData.append('MasterFactorId', this.submit_refer);
                    axios.post(url, formData, {}).then((res) => {


                        self.submit_refer = 0;
                        self.id_checkbox_items = [];

                        self.refer_person = null;

                        self.$root.modal_component.show_api_response_modals(res);
                        self.get_all_data()
                    })
                        .catch(function (error) {

                            console.log(error);
                        });
                } else {
                    self.id_checkbox_items.forEach((val) => {

                        const formData = new FormData();

                        formData.append('PersonId', this.refer_person);

                        formData.append('MasterFactorId', val);
                        axios.post(url, formData, {}).then((res) => {


                        })
                            .catch(function (error) {

                                console.log(error);
                            });
                    });
                    self.id_checkbox_items = [];
                    self.submit_refer = 0;
                    self.id_checkbox_items = [];

                    self.refer_person = null;

                    this.get_all_data()
                }


            },

        },

    }

</script>
